







































































































































































































































































import BaseComponent from '@/core/base.component';
import {
  AmenityDto,
  CompanyDto,
  CompanyDistrictDto,
  DeliverySpaceDto,
  DeliverySpaceCreateDto,
  DeliverySpaceListDto,
  DeliverySpaceOptionDto,
  BrandDto,
} from '@/dto';
import { Component, Prop } from 'vue-property-decorator';

import AmenityService from '../../../services/amenity.service';
import BrandService from '../../../services/brand.service';
import CompanyService from '../../../services/company.service';
import CompanyDistrictService from '../../../services/company-district.service';
import DeliverSpaceService from '../../../services/delivery-space.service';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';

import {
  ATTACHMENT_REASON_TYPE,
  FileAttachmentDto,
} from '../../../services/shared/file-upload';
import toast from '../../../../resources/assets/js/services/toast.js';
import { CONST_YN, YN } from '@/common';

@Component({
  name: 'DeliverySpaceCreate',
})
export default class DeliverySpaceCreate extends BaseComponent {
  private deliverySpaceCreateDto = new DeliverySpaceCreateDto();
  private attachments: FileAttachmentDto[] = [];
  private amenityList: AmenityDto[] = [];
  private amenityIds: number[] = [];
  private brandList: BrandDto[] = [];
  private brandIds: number[] = [];
  private deliverySpaceOptionIds: number[] = [];
  private companySelect: CompanyDto[] = [];
  private companyDistrictDto = new CompanyDistrictDto();
  private districtSelect: CompanyDistrictDto[] = [];
  private spaceOptions: DeliverySpaceOptionDto[] = [];
  private yn: YN[] = [...CONST_YN];
  private disabledYn = false;

  // delete images
  deleteImages(image) {
    if (this.attachments.includes(image)) {
      const index = this.attachments.indexOf(image);
      if (index > -1) {
        this.attachments.splice(index, 1);
      }
    }
  }

  // get brand
  getBrands() {
    BrandService.findForSelect().subscribe(res => {
      if (res) {
        this.brandList = res.data;
      }
    });
  }

  // TODO: Create autocomplete box
  getCompanies() {
    CompanyService.findForSelect().subscribe(res => {
      this.companySelect = res.data;
    });
  }

  // change compay select
  changeCompany(event) {
    const companyNo = event.target.value;
    this.getCompanyDistrict(companyNo);
  }

  // get company district select box
  getCompanyDistrict(companyNo) {
    this.companyDistrictDto.companyNo = companyNo;
    CompanyDistrictService.findForSelect(this.companyDistrictDto).subscribe(
      res => {
        if (res) {
          this.districtSelect = res.data;
        }
      },
    );
  }

  // add amenity array
  addAmenity(amenityId) {
    if (this.amenityIds.includes(parseInt(amenityId))) {
      const index = this.amenityIds.indexOf(parseInt(amenityId));
      if (index > -1) {
        this.amenityIds.splice(index, 1);
      }
    } else {
      this.amenityIds.unshift(parseInt(amenityId));
    }
  }

  // add delivery space option ids
  addDeliverySpaceOption(deliverySpaceOptionId) {
    if (this.deliverySpaceOptionIds.includes(parseInt(deliverySpaceOptionId))) {
      const index = this.deliverySpaceOptionIds.indexOf(
        parseInt(deliverySpaceOptionId),
      );
      if (index > -1) {
        this.deliverySpaceOptionIds.splice(index, 1);
      }
    } else {
      this.deliverySpaceOptionIds.unshift(parseInt(deliverySpaceOptionId));
    }
  }

  // add brand ids
  addBrand(brandId) {
    if (this.brandIds.includes(parseInt(brandId))) {
      const index = this.brandIds.indexOf(parseInt(brandId));
      if (index > -1) {
        this.brandIds.splice(index, 1);
      }
    } else {
      this.brandIds.unshift(parseInt(brandId));
    }
  }

  // 타입 생성
  create() {
    if (this.$route.params.id) {
      this.deliverySpaceCreateDto.companyDistrictNo = parseInt(
        this.$route.params.id,
      );
    }
    this.deliverySpaceCreateDto.amenityIds = this.amenityIds;
    this.deliverySpaceCreateDto.deliverySpaceOptionIds = this.deliverySpaceOptionIds;
    this.deliverySpaceCreateDto.brandIds = this.brandIds;

    this.deliverySpaceCreateDto.images = this.attachments;
    if (
      this.deliverySpaceCreateDto.images &&
      this.deliverySpaceCreateDto.images.length === 0 &&
      this.deliverySpaceCreateDto.delYn === YN.NO
    ) {
      toast.error('이미지 추가 후 노출 가능합니다.');
      return;
    }
    DeliverSpaceService.create(this.deliverySpaceCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.$root.$emit('delivery_space_create');
      }
    });
  }

  // 타입 생성 초기화
  clearOutCreateDto() {
    this.deliverySpaceCreateDto = new DeliverySpaceDto();
    this.amenityIds = [];
    this.deliverySpaceOptionIds = [];
    this.attachments = [];
  }

  // 이미지 업로드
  async upload(file: File[]) {
    const attachments = await FileUploadService.upload(
      UPLOAD_TYPE.DELIVERY_SPACE,
      file,
    );
    this.attachments = [];
    this.attachments.push(
      ...attachments.filter(
        fileUpload =>
          fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
      ),
    );
  }

  getQuantity(value) {
    if (value <= 0) {
      this.disabledYn = true;
      this.deliverySpaceCreateDto.isOpenedYn = this.yn[0];
    } else {
      this.disabledYn = false;
    }
  }

  getAmenities() {
    AmenityService.findAmenities('kitchen-facility').subscribe(res => {
      if (res) {
        this.amenityList = res.data;
      }
    });
  }

  getSpaceOptions() {
    DeliverSpaceService.findSpaceOption().subscribe(res => {
      if (res) {
        this.spaceOptions = res.data;
      }
    });
  }

  created() {
    this.getSpaceOptions();
    this.getAmenities();
    this.getCompanies();
    this.getBrands();
  }
}
